import React from 'react'
import SectionTitle from 'app/views/components/Headers&Text/SectionTitle'
import MainTable from 'app/views/components/Table/MainTable'
import { LetterOfCreditParams } from 'app/models/letter-of-credit'
import { columnDefs } from './locs-page-coumnDefs'
import LocsDetailPanel from './locs-detail-panel'
import {
  GridSortingStorage,
  GridPaginationStorage,
  GridColumnVisibilityStorage,
  useGridSorting,
  useGridPagination,
  useGridColumnVisibility,
} from 'app/utils/grid-sorting-storage'


interface ExpandableMantineTableProps {
  locs: LetterOfCreditParams[];
  globalLoading: boolean;
  title?: string;
}

const ExpandableMantineTable: React.FC<ExpandableMantineTableProps> = ({
  locs,
  globalLoading,
  title,
}) => {
  const [isInactiveLocs, setIsInactiveLocs] = React.useState(false)

  // Grid preferences hooks
  const { sorting, handleSortingChange } = useGridSorting(
    GridSortingStorage.facilityLocs,
  )
  const { pagination, handlePaginationChange } = useGridPagination(
    GridPaginationStorage.facilityLocs,
  )
  const { columnVisibility, handleColumnVisibilityChange } =
    useGridColumnVisibility(GridColumnVisibilityStorage.facilityLocs)

  const handleToggle = (isActive: boolean) => {
    setIsInactiveLocs(isActive)
  }

  // for now we do not have Inactive Locs but if we implement we will have with this logic

  const filteredLocs = React.useMemo(() => {
    if (isInactiveLocs) {
      return locs.filter((loc) => loc.status === 'Locked')
    }
    return locs.filter((loc) => loc.status !== 'Locked')
  }, [locs, isInactiveLocs])

  const renderDetailPanel = (row: {
    original: LetterOfCreditParams
    getIsExpanded: () => boolean
  }) => (
    <LocsDetailPanel
      row={row.original as any}
      isExpanded={row.getIsExpanded()}
    />
  )

  return (
    <>
      {title && <SectionTitle>{title}</SectionTitle>}
      {columnDefs.length != 0 ? (
        <MainTable
          tableName={title ?? ''}
          columnDefs={columnDefs}
          withPagination={true}
          data={filteredLocs ?? []}
          initialSorting={[
            { id: sorting.sortBy, desc: sorting.order === 'desc' },
          ]}
          onSortingChange={handleSortingChange}
          initialPagination={pagination}
          onPaginationChange={handlePaginationChange}
          initialColumnVisibility={columnVisibility}
          onColumnVisibilityChange={handleColumnVisibilityChange}
          setRow={() => { }}
          renderDetailPanel={({ row }) => renderDetailPanel(row)}
          csvExportEnabled
          enableTopToolbar={false}
          headerBackgroundColor="#F0EEEE"
          isLoading={globalLoading}
          isAccordionTable={true}
          showBottomBoolean={true}
          isInactiveLoanLocs={isInactiveLocs}
          onToggle={(isActive) => handleToggle(isActive)}
          border={true}
          controlSectionBorder={false}
        />
      ) : null}
    </>
  )
};


export default ExpandableMantineTable;
